import { AsyncPipe, DatePipe, isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, PLATFORM_ID, inject } from '@angular/core';
import { BrowserService } from '../../../services/browser.service';
import { MaintenanceService } from '../../../services/maintenance.service';
import { NotFoundComponent } from '../../../shared/components/not-found/not-found.component';
import { ReplacePipe } from '../../../shared/pipes/replace.pipe';

@Component({
  selector: 'app-tenant-profile-maintenance-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NotFoundComponent, AsyncPipe, DatePipe, ReplacePipe],
  templateUrl: './tenant-profile-maintenance-page.component.html',
})
export class TenantProfileMaintenancePageComponent {
  platformBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  maintenanceService = inject(MaintenanceService);
  browserService = inject(BrowserService);

  constructor() {
    if (this.platformBrowser) {
      setTimeout(() => {
        this.browserService.reload(true);
      }, 1000 * 10);
    }
  }
}
